<template lang="pug">
.resident-multiple-register-example-modal
  b-modal(ref="modal" size="xl" no-close-on-backdrop no-close-on-esc hide-footer scrollable)
    .resident-multiple-register-example-modal-header(slot="modal-header" slot-scope="{ cancel }")
      .float-left.title
        span 利用者情報一括登録のCSVファイルの仕様と作成例
      .float-right
        button(type="button" class="close" @click="cancel()") ×
    .resident-multiple-register-example-modal-body
      span.title CSVファイル仕様
      ul
        li
          span カンマ（,）区切りのCSVファイル。文字コードはSJISもしくはUTF-8。
        li
          span 1行目の1列目に「SERVICE_USER_INFO」と記載してください。
        li
          span 2行目に項目名、3行目以降に利用者登録情報を記載してください。
      span.title CSVファイルの項目名
      .resident-multiple-register-example-modal-table
        .thead
          .header-line
            .th.item-name 項目名
            .th.item-description 説明
            .th.item-required 必須
            .th.item-remarks 備考
        .tbody
          .body-line
            .td.item-name last_name
            .td.item-description 利用者名（姓）
            .td.item-required.justify-content-center.font-strong-color 必須
            .td.item-remarks 利用者名（名）と合わせて最大31文字。
          .body-line
            .td.item-name first_name
            .td.item-description 利用者名（名）
            .td.item-required.justify-content-center 任意
            .td.item-remarks 利用者名（姓）に姓名が記載されている場合、未記載にしてください。
          .body-line
            .td.item-name last_kana_name
            .td.item-description 利用者名（姓）ふりがな
            .td.item-required.justify-content-center 任意
            .td.item-remarks 利用者名（名）ふりがなと合わせて最大31文字。
          .body-line
            .td.item-name first_kana_name
            .td.item-description 利用者名（名）ふりがな
            .td.item-required.justify-content-center 任意
            .td.item-remarks 利用者名（姓）ふりがなに姓名が記載されている場合、未記載にしてください。
          .body-line
            .td.item-name gendar
            .td.item-description 性別
            .td.item-required.justify-content-center.font-strong-color 必須
            .td.item-remarks 半角数字のみ。男性の場合は「1」、女性の場合は「2」。未記載の場合は「無回答」で登録します。
          .body-line
            .td.item-name birthday
            .td.item-description 生年月日
            .td.item-required.justify-content-center 必須
            .td.item-remarks 半角数字のみ。西暦1921年5月26日の場合、「19210526」と記載してください。
          .body-line
            .td.item-name telephone
            .td.item-description 電話番号
            .td.item-required.justify-content-center 任意
            .td.item-remarks 半角数字と半角ハイフンのみ。
          .body-line
            .td.item-name room_name
            .td.item-description 部屋名
            .td.item-required.justify-content-center.font-strong-color 必須
            .td.item-remarks 最大32文字。
          .body-line
            .td.item-name group_name
            .td.item-description 利用者グループ名
            .td.item-required.justify-content-center 任意
            .td.item-remarks 登録済みの利用者グループ名を記載してください。未記載の場合は「無所属」で登録します。
          .body-line
            .td.item-name in_date
            .td.item-description 入居日
            .td.item-required.justify-content-center 任意
            .td.item-remarks 半角数字のみ。西暦2022年1月31日の場合、「20220131」と記載してください。
          .body-line
            .td.item-name in_time
            .td.item-description 入居時間
            .td.item-required.justify-content-center 任意
            .td.item-remarks 入居日を指定する場合は必須。10時30分の場合、「10:30」と記載してください。
          .body-line
            .td.item-name pick_up_time
            .td.item-description 入居送迎時間
            .td.item-required.justify-content-center 任意
            .td.item-remarks 9時30分の場合、「9:30」と記載してください。
          .body-line
            .td.item-name out_date
            .td.item-description 退去日
            .td.item-required.justify-content-center 任意
            .td.item-remarks 半角数字のみ。西暦2022年1月31日の場合、「20220131」と記載してください。
          .body-line
            .td.item-name out_time
            .td.item-description 退去時間
            .td.item-required.justify-content-center 任意
            .td.item-remarks 退去日を指定する場合は必須。10時30分の場合、「10:30」と記載してください。
          .body-line
            .td.item-name drop_off_time
            .td.item-description 退去送迎時間
            .td.item-required.justify-content-center 任意
            .td.item-remarks 9時30分の場合、「9:30」と記載してください。
          .body-line
            .td.item-name insured_number
            .td.item-description 保険者番号
            .td.item-required.justify-content-center 任意
            .td.item-remarks 半角数字6桁で記載してください。
          .body-line
            .td.item-name
              div(style="font-size: 12px;") care_insurance_insured_number
            .td.item-description 被保険者番号
            .td.item-required.justify-content-center 任意
            .td.item-remarks 半角英数字10桁で記載してください。
    .resident-multiple-register-example-modal-body
      span.title CSVファイルの作成例
      .resident-multiple-register-example-modal-example-table
        .tbody
          .body-line
            .td.file-name SERVICE_USER_INFO
          .body-line
            .td.last-name last_name
            .td.first-name first_name
            .td.last-kana-name last_kana_name
            .td.first-kana-name first_kana_name
            .td.gendar gendar
            .td.birthday birthday
            .td.telephone telephone
            .td.room-name room_name
            .td.group-name group_name
            .td.in-date in_date
            .td.in-time in_time
            .td.pick-up-time pick_up_time
            .td.out-date out_date
            .td.out-time out_time
            .td.drop-off-time drop_off_time
            .td.insured-number insured_number
            .td.care-insurance-insured_number care_insurance_insured_number
          .body-line
            .td.last-name 東京
            .td.first-name 太郎
            .td.last-kana-name とうきょう
            .td.first-kana-name たろう
            .td.gendar 1
            .td.birthday 19210526
            .td.telephone 090-0012-3456
            .td.room-name 101号室
            .td.group-name 東棟1階
            .td.in-date 20220131
            .td.in-time 10:30
            .td.pick-up-time 9:30
            .td.out-date 
            .td.out-time 
            .td.drop-off-time 
            .td.insured-number 
            .td.care-insurance-insured_number 
          .body-line
            .td.last-name 大阪 花子
            .td.first-name
            .td.last-kana-name おおさか はなこ
            .td.first-kana-name 
            .td.gendar 2
            .td.birthday 19411226
            .td.telephone
            .td.room-name 201号室
            .td.group-name
            .td.in-date 
            .td.in-time 
            .td.pick-up-time 
            .td.out-date 20210131
            .td.out-time 10:30
            .td.drop-off-time 9:30
            .td.insured-number 123456
            .td.care-insurance-insured_number 0123456789
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

/**
 * 利用者情報一括登録のCSVファイルの作成例モーダル
 */
@Component
export default class ResidentMultipleRegisterExampleModal extends Vue {
  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }
}
</script>
